import { Action, AnyAction, Reducer, ThunkAction } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
// import createSagaMiddleware from "redux-saga";
import thunk from 'redux-thunk';
import authenticationReducer from './authentication/authentication.slice';
import userDetailReducer from './authentication/user_detail';
import { configureAppStore } from './configureStore';
import createStyleReducer from './create-style/create-style.slice';
import { filterReducer } from './filter/filterSlice';
// import rootSaga from "./root_saga";
import { createEpicMiddleware } from 'redux-observable';
import cartReducer from './cart/cart.slice';
import globalReducer from './global/global.slice';
import personasReducer from './quiz_manager/personasSlice';
import quizReducer from './quiz_manager/quizSlice';
import styleReducer from './style';
import analyticReducer from './analytic/analytic.slice';
import widgetReducer from './widget/widget.slice';
import styleReviewReducer from './style_review';
import requestQuizReducer from './style_request_quiz/requestQuiz.slice';
import chatReducer from './chat/chat.slice';

const epicMiddleware = createEpicMiddleware();

const reducers = {
    global: globalReducer,
    analytic: analyticReducer,
    authentication: persistReducer(
        {
            key: 'authentication',
            version: 1,
            storage,
        },
        authenticationReducer,
    ),
    userDetail: persistReducer(
        {
            key: 'userDetail',
            version: 1,
            storage,
        },
        userDetailReducer,
    ),
    cart: cartReducer,
    chat: chatReducer,
    quiz: quizReducer,
    createStyle: createStyleReducer,
    personas: personasReducer,
    style: styleReducer,
    filter: persistReducer(
        {
            key: 'filter',
            stateReconciler: autoMergeLevel2,
            version: 1,
            storage,
        },
        filterReducer,
    ),
    widget: persistReducer(
        {
            key: 'widget',
            stateReconciler: autoMergeLevel2,
            version: 1,
            storage,
            whitelist: ['isAppInWidgetMode', 'isOpened', 'store', 'selectedQuestion', 'searchGender'],
        },
        widgetReducer as Reducer<unknown, AnyAction>,
    ),
    styleReview: styleReviewReducer,
    requestQuiz: persistReducer(
        {
            key: 'requestQuiz',
            version: 1,
            storage,
        },
        requestQuizReducer,
    ),
};

const middleware: any = [thunk, epicMiddleware];
export const store = configureAppStore(reducers, middleware);
export const persistor = persistStore(store);
// epicMiddleware.run(EPICS as any)
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;

//handle type for hook react to global
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
